import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

import { PortalApiService } from '../../core/portal-api.service';
import { I18nService } from '../../core/i18n.service';

// An employee's credit history: top-ups, renewals, spending and refunds.
// Read-only — adjusting a balance is a Frigg action, not a customer one.
@Component({
  selector: 'portal-ledger-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.employee.name || data.employee.email }}</h2>

    <mat-dialog-content>
      <div class="balance">
        <span class="balance-label">{{ 'ledgerDialog.currentBalance' | translate }}</span>
        <span class="balance-value">kr {{ kr(credit) }}</span>
      </div>

      <div class="state" *ngIf="loading">Loading…</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <table class="data" *ngIf="!loading && !error && entries.length">
        <thead>
          <tr>
            <th>{{ 'ledgerDialog.colDate' | translate }}</th>
            <th>{{ 'ledgerDialog.colWhat' | translate }}</th>
            <th class="num">{{ 'ledgerDialog.colAmount' | translate }}</th>
            <th class="num">{{ 'ledgerDialog.colBalance' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let e of entries">
            <td>{{ date(e.createdOn) }}</td>
            <td>{{ e.message || e.type }}</td>
            <td class="num" [class.neg]="e.type === 'debit'">
              {{ e.type === 'debit' ? '−' : '+' }}{{ kr(e.ammount) }}
            </td>
            <td class="num">{{ kr(e.balance) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="state" *ngIf="!loading && !error && !entries.length">
        {{ 'ledgerDialog.empty' | translate }}
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>{{ 'ledgerDialog.close' | translate }}</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .balance { display: flex; align-items: baseline; gap: 10px; margin-bottom: 14px; }
    .balance-label { font-size: 12px; color: #8593a1; text-transform: uppercase; letter-spacing: 0.4px; }
    .balance-value { font-size: 20px; font-weight: 600; color: #16324f; }
    .neg { color: #b3271e; }
  `]
})
export class LedgerDialogComponent implements OnInit {

  loading = true;
  error = '';
  credit = 0;
  entries: any[] = [];

  constructor(
    private api: PortalApiService,
    private i18n: I18nService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  async ngOnInit() {
    try {
      const res: any = await this.api.ledger(this.data.employee.membershipId);
      this.credit = (res && res.credit) || 0;
      this.entries = (res && res.entries) || [];
    } catch (err: any) {
      this.error = (err && err.error && err.error.message) || this.i18n.t('ledgerDialog.errorLoadFailed');
    }
    this.loading = false;
  }

  date(unix: number): string {
    return unix ? moment.unix(unix).format('DD.MM.YYYY HH:mm') : '—';
  }

  kr(v: number): string {
    return (Number(v) || 0).toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
